@if (title$ | async; as title) {
<!-- begin::Title -->
<h1 class="page-heading d-flex text-gray-900 fw-bold fs-2x my-0" [ngClass]="{
    'flex-column justify-content-center': appPageTitleDirection,
    'align-items-center': !appPageTitleDirection
  }">
  {{ title }}
  @if (appPageTitleDescription) { @if (description$ | async; as description) {
  <!--begin::Description-->
  <span class="page-desc text-muted fs-7 fw-semibold" [ngClass]="{ 'pt-2': appPageTitleDirection === 'column' }">
    @if (appPageTitleDirection === 'row') {
    <!--begin::Separator-->
    <span class="h-20px border-1 border-gray-300 border-start ms-3 mx-2"></span>
    <!--end::Separator-->
    }
    {{ description }}
  </span>
  <!--end::Description-->
  } }
</h1>
<!-- end::Title -->
<section class="d-none d-lg-block">
  @if (appPageTitleBreadcrumb) { @if (bc$ | async; as _bc) { @if (_bc.length >
  0) { @if (appPageTitleDirection === 'row') {
  <span class="h-20px border-gray-300 border-start mx-4"></span>
  }
  <!--begin::Breadcrumb-->
  <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-6 my-0"
    [ngClass]="{ 'pt-1': appPageTitleDirection === 'column' }">
    @for (bc of _bc; track $index) {
    <li class="breadcrumb-item" [ngClass]="!bc.isSeparator && bc.isActive ? 'text-gray-900' : ''"
      [ngClass]="!bc.isSeparator && !bc.isActive ? 'text-muted' : ''">
      @if (!bc.isSeparator) {
      <a class="d-flex flex-row align-items-center text-muted text-hover-primary" [routerLink]="bc.path"
        [queryParams]="bc.params || null">
        @if($index=== 0){
        <app-keenicon name="arrow-left" class="fs-4 me-2"></app-keenicon>

        }
        {{ bc.title }}
      </a>
      } @if (bc.isSeparator) {
      <span class="bullet bg-gray-200 w-5px h-2px"></span>
      }
    </li>
    }
    <li class="breadcrumb-item text-gray-900">{{ title }}</li>
  </ul>
  <!--end::Breadcrumb-->
  } } }
</section>

}